"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var use_long_press_1 = require("use-long-press");
var Button_less_1 = __importDefault(require("./Button.less"));
var Button = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, href = _a.href, disabled = _a.disabled, children = _a.children, onLongPress = _a.onLongPress, onDoubleClick = _a.onDoubleClick, props = __rest(_a, ["className", "href", "disabled", "children", "onLongPress", "onDoubleClick"]);
    var longPress = (0, use_long_press_1.useLongPress)(onLongPress, { detect: use_long_press_1.LongPressEventType.Pointer });
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        if (typeof props.onKeyDown === 'function') {
            props.onKeyDown(event);
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            // @ts-expect-error: Property 'buttonClickPrevented' does not exist on type 'KeyboardEvent'.
            if (!event.nativeEvent.buttonClickPrevented) {
                event.currentTarget.click();
            }
        }
    }, [props.onKeyDown]);
    var onMouseDown = (0, react_1.useCallback)(function (event) {
        if (typeof props.onMouseDown === 'function') {
            props.onMouseDown(event);
        }
        // @ts-expect-error: Property 'buttonBlurPrevented' does not exist on type 'MouseEvent'.
        if (!event.nativeEvent.buttonBlurPrevented) {
            event.preventDefault();
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    }, [props.onMouseDown]);
    return (0, react_1.createElement)(typeof href === 'string' && href.length > 0 ? 'a' : 'div', __assign(__assign(__assign({ tabIndex: 0 }, props), { ref: ref, className: (0, classnames_1.default)(className, Button_less_1.default['button-container'], { 'disabled': disabled }), href: href, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onDoubleClick: onDoubleClick }), longPress()), children);
});
exports.default = Button;
